import { __awaiter } from "tslib";
import { notes } from "@phoenixreisen/mithrils/src/notification";
import { changeCustomer } from "../../../shared/functions/fns.travel";
import { isValidInput } from "@phoenixreisen/form/src/functions";
import { checkbox } from "@phoenixreisen/form/src/fields";
import Model from "../model";
import m from "mithril";
const submit = (state, attrs, e) => __awaiter(void 0, void 0, void 0, function* () {
    const { customer, auth } = attrs.parent;
    const { form } = state;
    e === null || e === void 0 ? void 0 : e.preventDefault();
    if (isValidInput(form)) {
        try {
            state.spinner = true;
            customer["kundendaten/katalog-see"] = form.sea.value();
            customer["kundendaten/katalog-fluss"] = form.river.value();
            customer["kundendaten/katalog-orient"] = form.orient.value();
            customer["kundendaten/katalog-journal"] = form.journal.value();
            yield changeCustomer(customer, auth.jwt);
            notes.add({
                status: "success",
                text: "Ihre neue Auswahl wurde gespeichert.",
            });
        }
        catch (e) {
            notes.add({
                status: "error",
                text: `Ihre Auswahl konnte leider nicht gespeichert werden.
                    ${e["userfriendly-message"] || "Bitte probieren Sie es später erneut."}`,
            });
        }
        state.spinner = false;
        m.redraw();
    }
});
export default {
    oninit({ state, attrs }) {
        const { customer } = attrs.parent;
        state.form = {
            sea: checkbox(false),
            river: checkbox(false),
            orient: checkbox(false),
            journal: checkbox(false),
        };
        state.form.sea.value(customer["kundendaten/katalog-see"]);
        state.form.river.value(customer["kundendaten/katalog-fluss"]);
        state.form.orient.value(customer["kundendaten/katalog-orient"]);
        state.form.journal.value(customer["kundendaten/katalog-journal"]);
    },
    view({ state, attrs }) {
        const { webtexte } = Model;
        const { form, spinner } = state;
        const { sea, river, orient, journal } = form;
        return (m("article", { class: "abo-catalog-choice" },
            m("div", null, (webtexte === null || webtexte === void 0 ? void 0 : webtexte["katalogverwaltung__abonnements__text__auswahl"]) ? (m.trust(webtexte === null || webtexte === void 0 ? void 0 : webtexte["katalogverwaltung__abonnements__text__auswahl"])) : (m("p", null,
                "Haken Sie einfach die Kataloge an, die Sie von uns kostenlos beziehen m\u00F6chten. Wenn Sie alle abw\u00E4hlen, erhalten Sie auch keinen mehr - allerdings w\u00FCrden Sie dann",
                " ",
                m("strong", null, "viele tolle Infos & Angebote"),
                " verpassen!"))),
            m("form", { onsubmit: (e) => submit(state, attrs, e) },
                m("div", { class: "row row--2er" },
                    m("div", null,
                        m("label", { class: "checkbox" },
                            m("input", { name: "sea", type: "checkbox", disabled: spinner, value: sea.value(), checked: sea.value(), onclick: () => sea.validate(!sea.value()) }),
                            m("span", { class: "checkbox__label" }, "See"))),
                    m("div", null,
                        m("label", { class: "checkbox" },
                            m("input", { name: "orient", type: "checkbox", disabled: spinner, value: orient.value(), checked: orient.value(), onclick: () => orient.validate(!orient.value()) }),
                            m("span", { class: "checkbox__label" }, "Orient")))),
                m("div", { class: "row row--2er" },
                    m("div", null,
                        m("label", { class: "checkbox" },
                            m("input", { name: "river", type: "checkbox", disabled: spinner, value: river.value(), checked: river.value(), onclick: () => river.validate(!river.value()) }),
                            m("span", { class: "checkbox__label" }, "Fluss"))),
                    m("div", null,
                        m("label", { class: "checkbox" },
                            m("input", { name: "magazine", type: "checkbox", disabled: spinner, value: journal.value(), checked: journal.value(), onclick: () => journal.validate(!journal.value()) }),
                            m("span", { class: "checkbox__label" }, "Magazin")))),
                m("div", { class: "mt3" },
                    m("button", { type: "submit", disabled: spinner },
                        spinner && m("i", { class: "fas fa-spinner fa-spin mr2" }),
                        "Auswahl speichern")))));
    },
};
